module.exports = __webpack_public_path__ + "img/map_2.e9658bba.jpg";